module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inform"
  }, [_c('div', {
    staticClass: "informContent"
  }, [(_vm.content.length > 0) ? _c('pull-to', {
    attrs: {
      "bottom-load-method": _vm.bottomChangeFn,
      "top-load-method": _vm.topChangeFn
    }
  }, [_c('ul', _vm._l((_vm.content), function(item, index) {
    return _c('xk-inform-time-mod', {
      key: index,
      attrs: {
        "time": item ? item.created : null,
        "content": item ? item.content : null
      }
    })
  }), 1)]) : _c('div', {
    staticClass: "wujilv"
  }, [_c('h2', [_vm._v("暂无消息通知")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ddbfb52","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/inform/inform.vue
// module id = 550
// module chunks = 0